var onCreateAccountPage = document.getElementById('Form_RegisterForm')

var passwordInput = null
var confirmPasswordInput = null
var silverstripeError = null
var submit = null

var newPasswordInput = document.getElementById('Form_RegisterForm_Password_Password')
var confirmNewPasswordInput = document.getElementById('Form_RegisterForm_Password_ConfirmPassword')
var changePasswordInput = document.getElementById('ChangePasswordForm_ChangePasswordForm_NewPassword1')
var confirmChangePasswordInput = document.getElementById('ChangePasswordForm_ChangePasswordForm_NewPassword2')

var passwordRules = document.getElementById('password-rules')
var passwordSuccess = document.getElementById('password-success')

if (passwordRules) {
  var letter = document.getElementById('letter')
  var symbol = document.getElementById('symbol')
  var number = document.getElementById('number')
  var length = document.getElementById('length')
  var match = document.getElementById('match')
}

var passwordTogglerEye = document.querySelector('#toggle-Form_RegisterForm_Password_Password > .eye')
var passwordTogglerEyeSlash = document.querySelector('#toggle-Form_RegisterForm_Password_Password > .eye-slash')
var confirmPasswordTogglerEye = document.querySelector('#toggle-Form_RegisterForm_Password_ConfirmPassword > .eye')
var confirmPasswordTogglerEyeSlash = document.querySelector('#toggle-Form_RegisterForm_Password_ConfirmPassword > .eye-slash')

function passwordIsValid() {
  return passwordRules.getElementsByClassName('invalid').length === 0
}

function updateValidStatus(el, rulePassed) {
  if (rulePassed) {
    el.classList.remove('invalid')
    el.classList.add('valid')
  } else {
    el.classList.remove('valid')
    el.classList.add('invalid')
  }
}

function showSuccessMessage() {
  passwordRules.classList.add('hide')
  passwordSuccess.classList.remove('hide')
}

function showPasswordRules() {
  passwordRules.classList.remove('hide')
  passwordSuccess.classList.add('hide')
}

function showPassword(input, eye, eyeSlash) {
  input.setAttribute('type', 'text')
  eye.classList.add('hide')
  eyeSlash.classList.remove('hide')
}

function hidePassword(input, eye, eyeSlash) {
  input.setAttribute('type', 'password')
  eye.classList.remove('hide')
  eyeSlash.classList.add('hide')
}

function fieldsAreComplete() {
  if (onCreateAccountPage) {
    if (emailInput.value.length > 0 && termsInput.checked && passwordIsValid()) {
      return true
    } else {
      return false
    }
  } else {
    return passwordIsValid()
  }
}

function toggleSubmitButton() {
  if (fieldsAreComplete()) {
    submit.disabled = false
    submit.classList.remove('c-button--disabled')
  } else {
    submit.disabled = true
    submit.classList.add('c-button--disabled')
  }
}

if (newPasswordInput && confirmNewPasswordInput) {
  passwordInput = newPasswordInput
  confirmPasswordInput = confirmNewPasswordInput

  var emailInput = document.getElementById('Form_RegisterForm_Email')
  var termsInput = document.getElementById('Form_RegisterForm_TermsAgreement')
} else if (changePasswordInput && confirmChangePasswordInput) {
  passwordInput = changePasswordInput
  confirmPasswordInput = confirmChangePasswordInput

  passwordTogglerEye = document.querySelector('#toggle-ChangePasswordForm_ChangePasswordForm_NewPassword1 > .eye')
  passwordTogglerEyeSlash = document.querySelector(
    '#toggle-ChangePasswordForm_ChangePasswordForm_NewPassword1 > .eye-slash',
  )
  confirmPasswordTogglerEye = document.querySelector(
    '#toggle-ChangePasswordForm_ChangePasswordForm_NewPassword2 > .eye',
  )
  confirmPasswordTogglerEyeSlash = document.querySelector(
    '#toggle-ChangePasswordForm_ChangePasswordForm_NewPassword2 > .eye-slash',
  )
}

if (passwordInput && confirmPasswordInput) {
  passwordTogglerEye.classList.remove('hide')
  confirmPasswordTogglerEye.classList.remove('hide')
  submit = document.querySelector('input[type=submit]')
  submit.disabled = true
  submit.classList.add('c-button--disabled')

  passwordInput.onfocus = function() {
    if (!passwordIsValid()) {
      showPasswordRules()
    }
    silverstripeError = passwordRules.parentElement.previousElementSibling.classList.contains('message')
    if (silverstripeError) {
      passwordRules.parentElement.previousElementSibling.style.display = 'none'
    }
  }

  passwordInput.addEventListener('input', () => {
    var letters = /[A-Za-z]/g
    updateValidStatus(letter, passwordInput.value.match(letters))

    var symbols = /[^A-Za-z0-9]/g
    updateValidStatus(symbol, passwordInput.value.match(symbols))

    var numbers = /[0-9]/g
    updateValidStatus(number, passwordInput.value.match(numbers))

    updateValidStatus(length, passwordInput.value.length >= 10)

    updateValidStatus(match, passwordInput.value === confirmPasswordInput.value && passwordInput.value != '')

    if (passwordIsValid()) {
      showSuccessMessage()
    } else {
      showPasswordRules()
    }

    toggleSubmitButton()
  })

  confirmPasswordInput.addEventListener('input', () => {
    updateValidStatus(match, passwordInput.value === confirmPasswordInput.value && passwordInput.value != '')

    if (passwordIsValid()) {
      showSuccessMessage()
    } else {
      showPasswordRules()
    }

    toggleSubmitButton()
  })

  if (onCreateAccountPage) {
    emailInput.addEventListener('input', () => {
      toggleSubmitButton()
    })

    termsInput.addEventListener('change', () => {
      toggleSubmitButton()
    })
  }

  passwordTogglerEye.addEventListener('click', () => {
    showPassword(passwordInput, passwordTogglerEye, passwordTogglerEyeSlash)
  })

  passwordTogglerEyeSlash.addEventListener('click', () => {
    hidePassword(passwordInput, passwordTogglerEye, passwordTogglerEyeSlash)
  })

  confirmPasswordTogglerEye.addEventListener('click', () => {
    showPassword(confirmPasswordInput, confirmPasswordTogglerEye, confirmPasswordTogglerEyeSlash)
  })

  confirmPasswordTogglerEyeSlash.addEventListener('click', () => {
    hidePassword(confirmPasswordInput, confirmPasswordTogglerEye, confirmPasswordTogglerEyeSlash)
  })
}
